<se-fe-chip-group>
  <se-fe-chip
    [seFeTestId]="{ label: 'StatusChip', isRoot: true }"
    [seFeDataText]="'DISCOUNTS.LIST_VIEW.FILTERS.status' | translate"
    [seFeDataAriaLabel]="'DISCOUNTS.LIST_VIEW.FILTERS.status_filter' | translate"
    seFeDataIconRight="chevron_down"
    [seFeDataSelected]="selectedStatuses().length > 0"
    [seFeDataDisabled]="disabled()"
    [seFeMenuTrigger]="statusMenu"
    (seFeClick)="onMenuOpened()"></se-fe-chip>

  <se-fe-menu-filter #statusMenu class="status-filter-menu" [seFeDataOptions]="statusMenuOptions">
    <div seFeMenuContent>
      <form [formGroup]="form">
        <se-fe-checkboxes formControlName="statuses" [seFeDataOptions]="statusOptions"></se-fe-checkboxes>
      </form>
    </div>
  </se-fe-menu-filter>
</se-fe-chip-group>
